// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3smYg","additionalInfo":"AgreementModal_additionalInfo__1gQCg"};